<template>
  <Card>
    <div
      v-dragndrop
      class="bids-add-bulk-drop"
      @drop.prevent="validateAndProcessFile"
    >
      <Transition name="fade-transform" mode="out-in">
        <div v-if="!isProcessing" class="bids-add-bulk-drop__upload-content">
          <header class="bids-add-bulk-drop__header">
            <img
              src="~@/assets/images/drag-drop.svg"
              class="bids-add-bulk-drop__header-img"
            />
          </header>
          <div class="bids-add-bulk-drop__content-wrapper">
            <p class="bids-add-bulk-drop__description">
              {{ $t('ADVERTISEMENT.BULK_IMPORT.DROPPABLE_DESCRIPTION') }}
            </p>
            <input
              ref="fileInput"
              accept=".csv"
              type="file"
              class="input input--invisible"
              @change="validateAndProcessFile"
            />
            <ElButton
              type="primary"
              class="bids-add-bulk-drop__upload-btn"
              @click="selectFile"
            >
              {{ $t('ADVERTISEMENT.BULK_IMPORT.BUTTON_TEXT') }}
            </ElButton>
          </div>
        </div>
        <BidsAddBulkDropLoading v-else :file-name="fileName" />
      </Transition>
    </div>
  </Card>
</template>

<script>
import Card from '@@/common/Card';
import BidsAddBulkDropLoading from './BidsAddBulkDropLoading';
import form from '@/mixins/form';
import csv from '@/utils/csv';
import dragndrop from '@/directives/dragndrop';

export default {
  name: 'BidsAddBulkDrop',
  components: {
    BidsAddBulkDropLoading,
    Card,
  },
  directives: {
    dragndrop,
  },
  mixins: [form],
  data() {
    return {
      isProcessing: false,
      fileName: '',
    };
  },
  methods: {
    selectFile() {
      this.$refs['fileInput'].click();
    },
    validateAndProcessFile(e) {
      const files = this.getFiles(e);
      if (!files || !files.length) return false;

      const selectedFile = files[0];

      this.processFile(selectedFile);
    },
    processFile(selectedFile) {
      this.isProcessing = true;

      this.fileName = selectedFile.name;

      return csv
        .parse(selectedFile, { worker: true, perColumn: true })
        .then(({ data }) => {
          this.$emit('upload', data);
        })
        .catch(() => {
          this.$message.error(
            this.$t('ADVERTISEMENT.BULK_IMPORT.PROCESS_ERROR'),
          );
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>

<style lang="scss">
.bids-add-bulk-drop {
  border: 2px dashed $lb-color-primary;
  border-radius: $lb-border-radius;

  height: rem-calc(540px);

  background-color: #fff;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__header {
    margin-bottom: $global-margin * 1.5;
    text-align: center;
  }

  &__content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;
    max-width: rem-calc(500px);
    color: $lb-color-text-secondary;
  }

  &__description {
    margin-bottom: $global-margin * 1.5;
    text-align: center;
  }
}
</style>
